export default __webpack_public_path__ + "static/media/tectos.c632f7cb.webp";